import UserScoreCard from './UserScoreCard';

export default UserScoreCard;
